import Vue from 'vue'
import Vuex from 'vuex'
import VuePrism from 'vue-prism'
import App from './App.vue'
import axios from 'axios'

Vue.use(Vuex)
Vue.use(VuePrism)

import 'prismjs/components/prism-json.js'
import 'prismjs/themes/prism.css'

const connect_poly = (polygons) => {
    let newpolygons = []
    for (let poly of polygons) {
        let newpoly = poly.slice()
        let len = poly.length
        if (poly[0] !== poly[len-2] || poly[1] !== poly[len-1]) {
            newpoly.push(poly[0])
            newpoly.push(poly[1])
        }
        newpolygons.push(newpoly)
    }
    return newpolygons
}

const store = new Vuex.Store({
    state: {
        subject: [],
        clipping: [],
        result: [],
        calc: false,
        operation: 'AND'
    },
    mutations: {
        update_subject (state, payload) {
            state.subject = connect_poly(payload)
        },
        update_clipping (state, payload) {
            state.clipping = connect_poly(payload)
        },
        update_result (state, payload) {
            state.result = connect_poly(payload)
        },
        clear_result (state) {
            state.result = []
        },
        start_calc (state) {
            state.calc = true
        },
        end_calc (state) {
            state.calc = false
        },
        do_and (state) {
            state.operation = 'AND'
        },
        do_not (state) {
            state.operation = 'NOT'
        },
        do_or (state) {
            state.operation = 'OR'
        },
        do_xor (state) {
            state.operation = 'XOR'
        }
    },
    actions: {
        clip ({ commit, state}, payload) {
            commit('update_subject', payload.subject)
            commit('update_clipping', payload.clipping)
            switch (payload.operation) {
                case 'AND': commit('do_and'); break;
                case 'OR': commit('do_or'); break;
                case 'NOT': commit('do_not'); break;
                case 'XOR': commit('do_xor'); break;
            }
            commit('clear_result')
            commit('start_calc')
            axios.post('/api/clip', {
                subject: state.subject,
                clipping: state.clipping,
                operation: state.operation
            })
            .then((res) => {
                commit('update_result', res.data.result)
                commit('end_calc')
            })
            .catch((error) => {
                console.log(error)
            })
        }
    }
})

new Vue({
  el: '#app',
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js